import React from 'react'
import StatsAndStandingsHomeNavigation from './StatsAndStandingsHomeNavigation'
import SelectLeague from '../UIElements/SelectLeague'
import Banner from './Banner'
import Footer from '../UIElements/Footer'
import './StatsAndStandingsHome.css'

const StatsAndStandingsHome = () => {
	return (
		<div>
			{/* StatsAndStandingsHomeNavigation contains HomeHeader (just says Stats & Standings)
			and the HomeNavLinks (which is the ADMIN button on the far right) */}
			<StatsAndStandingsHomeNavigation />
			<Banner />
			<SelectLeague />
		</div>
	)
}

export default StatsAndStandingsHome
